<template>
  <div class="form-header">
        <div class="form-title">
            <span class="title"><span class="title-tip"></span>{{pageTitle}}</span>
        </div> 
        <div class="form-button-wrapper">
            <div class="opration-btn">
                <button type="button" class="el-button btn-font el-button--primary el-button--small" @click="save">
                    <span>
                        <i class="iconfont icon-baocun"></i>
                        <label>保存</label>
                    </span>
                </button>
            </div>
            <div class="opration-btn">
                <button type="button" class="el-button btn-font el-button--default el-button--small" @click="back">
                    <span>
                        <i class="iconfont icon-fanhui"></i> 
                        <label>取消</label>
                    </span>
                </button>
            </div> 
        </div>
    </div>
</template>
<script>
export default {
  name: 'form-header',
  props: {
    pageTitle: String
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    save() {
      this.$emit('save')
    },
    back() {
      this._gobackRefresh(this, this.$route.fullPath)
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
    .form-header {
        // display: flex;
        border-bottom: 1px solid #d6d8d7;
        margin-left:20px;

        & > div {
            display: inline-block;
            width: 49%;
            height: 50px;
            line-height: 48px;
        }
        .form-title {
            text-align: left;
             
            .title {
                display: inline-block;
                //border-bottom: 2px solid #4097D9;
                .title-tip {
                    white-space: nowrap;
                    width: 2px;
                    border-radius: 2px;
                    height: 16px;
                    display: inline-block;
                    position: relative;
                    left: 0;
                    top:-1px;
                    vertical-align: middle;
                    background: #4097d9;
                    margin-right: 10px;
                }
            }
        }
        .form-button-wrapper {
            text-align: right;
            // padding-right: 20px;
            .opration-btn {
                display: inline-block;
                padding-left: 5px;
                padding-right: 5px;

                & > .el-button {
                    vertical-align: middle;
                    background-color: #4097D9;
                    color: #fff;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/components/form-header.vue